import React, { useEffect, useRef, useState } from "react";
import cancel from "../../../favicon/cancel.svg";
import { Notification, useToaster, Uploader } from "rsuite";
import { APIRequest, ApiUrl } from "../../../Helpers/ApiHelper";
import hasError from "../../../Helpers/ErrorHelper";
import CustomLoader from "../../comman/Loader/CustomLoader";
import currencyFormatter from "../../../Helpers/currencyFormatter";
import plusAdd from "../../../favicon/plus.svg";
import { addDays } from "date-fns";
import DatePicker from "react-date-picker";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import Select from "react-select";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import { motion } from "framer-motion";
import { MdClear } from "react-icons/md";
import customValidation from "../../../Helpers/customValidation";

const CreateCampaignModal = ({ showCreate, setShowCreate }) => {
  const [campaignData, setCampaignData] = useState([]);
  const [formData, setFormData] = useState([]);
  const [socialPlatformsData, setSocialPlatformData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [validationErrors, setValidationErrors] = useState([]);
  const [open, setOpen] = useState(false);
  const refOne = useRef(null);
  const [fileList, setFileList] = useState("");
  const [fileInfo, setFileInfo] = useState(null);

  const toaster = useToaster();

  useEffect(() => {
    getCampaignCreateData();
    // document.addEventListener("click", hideOnClickOutside, true);
  }, []);

  const colourStylesStatic = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "white !important",
      borderRadius: "8px",
      borderColor: "#E5E5E5",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,

        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? "#40ba47"
          : isFocused
          ? "#e1ffed"
          : "#7F7F7F",
        borderColor: isDisabled
          ? undefined
          : isSelected
          ? "#575757"
          : isFocused
          ? "#575757"
          : undefined,
        borderRadius: isDisabled
          ? "8px"
          : isSelected
          ? "undefined"
          : isFocused
          ? "undefined"
          : "undefined",
        color: isDisabled
          ? "#575757"
          : isSelected
          ? "#575757"
          : isFocused
          ? "#40ba47"
          : "#ffff",
        cursor: isDisabled ? "not-allowed" : "pointer",

        ":active": {
          ...styles[":active"],
          backgroundColor: !isDisabled
            ? isSelected
              ? "#40ba47"
              : "#40ba47"
            : undefined,
        },
      };
    },
    multiValue: (styles, { data }) => {
      const color = "white";
      return {
        ...styles,
        borderColor: "#00b048",
        backgroundColor: "#40ba47",
        color: "#ffff",
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: "#ffff",
      borderRadius: "2px 0 0 2px",
      backgroundColor: "#40ba47",
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: "#fff",
      borderRadius: "0 2px 2px 0",
      backgroundColor: "#008839",
      ":hover": {
        backgroundColor: "#40ba47",
        color: "white",
      },
    }),
  };

  const hideOnClickOutside = (e) => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      setOpen(false);
    }
  };

  const getCampaignCreateData = () => {
    let config = {
      url: ApiUrl.getCampaignCreationData,
      method: "GET",
      body: {},
    };

    APIRequest(
      config,
      (res) => {
        setIsLoading(false);
        setCampaignData(res.data);
        console.log("campaignData",campaignData);
        
        setSocialPlatformData(res.data.social_platForms_list);
      },

      (err) => {
        setIsLoading(false);
      }
    );
  };

  const handleSocialPlateforClick = (item) => {
    const updatedItem = { ...item, selected: !item.selected };
    const updatedSocialPlatform = socialPlatformsData.map((sp) =>
      sp.value === updatedItem?.value ? updatedItem : sp
    );
    setSocialPlatformData(updatedSocialPlatform);
  };

  const handleRangeforClick = (item, rangeData) => {
    const updatedRangeData = { ...rangeData, selected: !rangeData?.selected };
    const updatedRangeArray = item?.range_data.map((rd) =>
      rd.id === updatedRangeData.id ? updatedRangeData : rd
    );
    const updatedItem = { ...item, range_data: updatedRangeArray };
    const updatedSocialPlatform = socialPlatformsData.map((sp) =>
      sp.value === item?.value ? updatedItem : sp
    );
    setSocialPlatformData(updatedSocialPlatform);
  };

  const handleRangeTaskInfoChange = (e, item, rangeData) => {
    const value = e.target.value;
    const updatedRangeData = { ...rangeData, task_info: value };
    const updatedRangeArray = item?.range_data.map((rd) =>
      rd.id === updatedRangeData.id ? updatedRangeData : rd
    );
    const updatedItem = { ...item, range_data: updatedRangeArray };
    const updatedSocialPlatform = socialPlatformsData.map((sp) =>
      sp.value === item?.value ? updatedItem : sp
    );
    setSocialPlatformData(updatedSocialPlatform);
  };

  const addMoreRows = (e, item, rangeData) => {
    e.preventDefault();
    let from = "";
    if (rangeData?.range?.length >= 1) {
      const prevRow = rangeData?.range[rangeData?.range?.length - 1];
      if (prevRow?.from === "") {
        toaster.push(
          <Notification type="warning" header="Warning">
            Please provide FROM range{" "}
          </Notification>,
          {
            placement: "topEnd",
          }
        );
        return;
      }
      if (prevRow?.to === "") {
        toaster.push(
          <Notification type="warning" header="Warning">
            Please provide TO range{" "}
          </Notification>,
          {
            placement: "topEnd",
          }
        );
        return;
      }
      if (prevRow?.amount === "") {
        toaster.push(
          <Notification type="warning" header="Warning">
            Please provide AMOUNT range{" "}
          </Notification>,
          {
            placement: "topEnd",
          }
        );
        return;
      }
      from = parseInt(prevRow?.to) + 1;
    }
    const newRange = {
      from: from,
      to: "",
      id: rangeData?.range?.length + 1,
      amount: "",
    };
    const updatedRange = [...rangeData?.range, newRange];
    const updatedRangeData = { ...rangeData, range: updatedRange };
    const updatedRangeDataItems = item?.range_data.map((rd) =>
      rd.id === updatedRangeData.id ? updatedRangeData : rd
    );
    const updatedItem = { ...item, range_data: updatedRangeDataItems };
    const updatedSocialPlatform = socialPlatformsData.map((sp) =>
      sp.value === updatedItem?.value ? updatedItem : sp
    );
    setSocialPlatformData(updatedSocialPlatform);
  };

  const removeRow = (e, item, rangeData, row) => {
    e.preventDefault();
    const updatedRange = rangeData?.range.filter((r) => r.id !== row?.id);
    const updatedRangeData = { ...rangeData, range: updatedRange };
    const updatedRangeDataItems = item?.range_data.map((rd) =>
      rd.id === updatedRangeData.id ? updatedRangeData : rd
    );
    const updatedItem = { ...item, range_data: updatedRangeDataItems };
    const updatedSocialPlatform = socialPlatformsData.map((sp) =>
      sp.value === updatedItem?.value ? updatedItem : sp
    );
    setSocialPlatformData(updatedSocialPlatform);
  };

  const isNumber = (evt, name) => {
    if (name === "amount" || name === "budget") {
      if (evt?.target?.value.includes("-") || evt?.target?.value === "0") {
        return false;
      } else return true;
    } else {
      return true;
    }
  };
  const isNegativeNumber = (value) => {
    if (value.includes("-") || value === "0") {
      return true;
    } else return false;
  };

  const handleRangeChange = (e, item, rangeData, r, name, i) => {
    e.stopPropagation();
    const isValid = isNumber(e, name);
    if (isValid) {
      const value = e.target.value;
      let updatedRangeItem = { ...r, [name]: value };
      updatedRangeItem = checkRangeStartFromJustLastTo(
        rangeData?.range,
        updatedRangeItem,
        i
      );
      updatedRangeItem = checkCurrentRowFromTOValues(updatedRangeItem, name);
      let updatedRange = rangeData?.range?.map((rg) =>
        rg.id === r.id ? updatedRangeItem : rg
      );
      updatedRange = changeNextFromIfPrevChnages(updatedRange, i, name);
      const updatedRangeData = { ...rangeData, range: updatedRange };
      const updatedRangeDataItems = item?.range_data.map((rd) =>
        rd.id === updatedRangeData.id ? updatedRangeData : rd
      );
      const updatedItem = { ...item, range_data: updatedRangeDataItems };
      const updatedSocialPlatform = socialPlatformsData.map((sp) =>
        sp.value === updatedItem?.value ? updatedItem : sp
      );
      const currentAlloction = checkBudget(updatedSocialPlatform);
      // const rowTotalAmount = (updatedRangeItem.amount !== '' && updatedRangeItem.from !== '' && updatedRangeItem.to !== '') ? ((parseFloat(updatedRangeItem.to) - parseFloat(updatedRangeItem.from) + 1) * (parseFloat(updatedRangeItem.amount))) : 0.00;

      if (parseFloat(formData?.budget) < currentAlloction) {
        toaster.push(
          <Notification type="warning" header="Warning">
            Your allocated budget is more than Budget Pool
          </Notification>,
          {
            placement: "topEnd",
          }
        );
        return false;
      }
      setSocialPlatformData(updatedSocialPlatform);
    }
  };

  const checkRangeStartFromJustLastTo = (range, currentData, index) => {
    let from = currentData?.from;
    if (index > 0) {
      const prevRow = range[index - 1];
      if (parseInt(currentData?.from) <= parseInt(prevRow?.to)) {
        from = parseInt(prevRow?.to) + 1;
      }
      if (parseInt(currentData?.from) - parseInt(prevRow?.to) > 1) {
        from = parseInt(prevRow?.to) + 1;
      }
    }
    return { ...currentData, from: from };
  };

  const checkCurrentRowFromTOValues = (currentData, name) => {
    let error = currentData?.error === undefined ? "" : currentData?.error;
    if (parseInt(currentData?.from) >= parseInt(currentData?.to)) {
      if (name === "to") {
        error = {
          [name]: `To value must be greater than ${currentData?.from}`,
        };
      }
      if (name === "from") {
        error = { [name]: `From value must be less than ${currentData?.to}` };
      }
    } else {
      error = "";
    }
    return { ...currentData, error: error };
  };

  const changeNextFromIfPrevChnages = (range, i, name) => {
    const nextRow = range[i + 1];
    const currentRow = range[i];

    if (name === "to" && nextRow !== undefined) {
      const finalItrationLength = i + 1;
      range = range?.filter(
        (item, itration) => itration <= finalItrationLength
      );
      range = range?.map((item, index) =>
        index > i
          ? index === i + 1
            ? {
                ...nextRow,
                from: parseInt(currentRow?.to) + 1,
                to: "",
                amount: "",
              }
            : { ...nextRow, from: "", to: "", amount: "" }
          : item
      );
    }

    return range;
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    let selected_soical_platforms = socialPlatformsData.filter(
      (sp) => sp.selected
    );
    let selectedRangesTypes = 0;
    let hasError = false;
    selected_soical_platforms.forEach((sp) => {
      sp.range_data = sp.range_data.filter((rd) => rd.selected);
      selectedRangesTypes =
        parseInt(selectedRangesTypes) + parseInt(sp.range_data.length);
      sp.range_data?.forEach((element) => {
        element?.range?.forEach((range) => {
          if (range?.error !== "") {
            hasError = true;
            toaster.push(
              <Notification type="warning" header="Warning">
                Please correct the budget range{" "}
              </Notification>,
              {
                placement: "topEnd",
              }
            );
            return false;
          }
        });
      });
    });
    if (selectedRangesTypes <= 0) {
      toaster.push(
        <Notification type="warning" header="Warning">
          Please select buget allocation for any range eg:Like ,Share ,Comment
          etc{" "}
        </Notification>,
        {
          placement: "topEnd",
        }
      );
      return;
    }
    if (!hasError) {
      setIsLoading(true);
      let config = {
        url: ApiUrl.addCampaign,
        method: "POST",
        body: {
          ...formData,
          gender: formData?.gender?.map((g) => g.value),
          marital_status: formData?.marital_status?.map((g) => g.value),
          age: formData?.age?.map((g) => g.value),
          occupation: formData?.occupation?.map((g) => g.value),
          category_id: formData?.category_id?.value,
          location_id: formData?.location_id?.value,
          budgetAllocation: selected_soical_platforms,
        },
      };
      APIRequest(
        config,
        (res) => {
          setIsLoading(false);
          setShowCreate(false);
          clearFormData();

          toaster.push(
            <Notification type="success" header="Success">
              {res?.message}{" "}
            </Notification>,
            {
              placement: "topEnd",
            }
          );
        },

        (err) => {
          setIsLoading(false);
          if (err.response.status === 422)
            setValidationErrors(err?.response?.data.errors);

          if (err.response.status === 423)
            toaster.push(
              <Notification type="warning" header="Warning">
                {err?.response?.data?.error}{" "}
              </Notification>,
              {
                placement: "topEnd",
              }
            );
        }
      );
    }
  };

  const clearFormData = () => {
    setFormData({});
    setSocialPlatformData({});
  };

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  const handleOnChangeDatePicker = (name, value) => {
    hideValidationOnChange(name);

    const updatedDate = value !== undefined ? formatDate(value) : "";

    const updatedFormData = {
      ...formData,
      [name]: updatedDate,
    };
    setFormData(updatedFormData);
  };

  const handleOnChangeDateRangePicker = (name, value) => {
    hideValidationOnChange(name);

    const fDate = value !== null ? formatDate(value[0]) : "";
    const lDate = value !== null ? formatDate(value[1]) : "";
    const sortDates = {
      start_date: fDate,
      end_date: lDate,
    };

    const updatedFormData = {
      ...formData,
      [name]: sortDates,
    };
    setFormData(updatedFormData);

    // }
  };

  const hideValidationOnChange = (name) => {
    const IsError = validationErrors?.find((v) => v.field === name);

    if (IsError !== undefined) {
      setValidationErrors(validationErrors?.filter((v) => v.field !== name));
    }
  };

  const handleOnChange = (val, name) => {
    hideValidationOnChange(name);
    // if (name === 'budget') {
    //     if (isNegativeNumber(val)) {
    //         return false;
    //     }
    // }

    if (name === "budget") {
      if (!customValidation.isPositveIntegerNumber(val)) {
        return false;
      }
    }

    const updatedFormData = {
      ...formData,
      [name]: val,
    };
    setFormData(updatedFormData);
  };

  const checkBudget = (socialPlatformsData) => {
    var allocatedBudget = 0.0;
    socialPlatformsData.forEach((element) => {
      if (element.range_data.length > 0) {
        element.range_data.forEach((rangeData) => {
          if (rangeData?.range?.length > 0) {
            let total_amount = rangeData?.range
              ?.filter((d) => d.amount !== "" && d.from !== "" && d.to !== "")
              ?.reduce(
                (pre, curr) =>
                  pre +
                  (parseFloat(curr.to) - parseFloat(curr.from) + 1) *
                    parseFloat(curr.amount),
                0.0
              );
            allocatedBudget =
              parseFloat(allocatedBudget) + parseFloat(total_amount);
          }
        });
      }
    });
    return allocatedBudget;
  };

  const handleCamAvatarUpload = (data) => {
    const updatedFormData = {
      ...formData,
      campaignLogo: data,
    };
    hideValidationOnChange("campaignLogo");
    setFormData(updatedFormData);

    setFileList(data);
  };

  const onRemoveFile = (file) => {
    setFormData({
      ...formData,
      campaignAvatar: "",
    });

    if (file.status === "finished" || file.status === "inited") {
      setFileList("");
    }
  };

  const currentRowTotal = (row) => {
    if (row?.amount !== "") {
      if (row?.from !== "" && row?.to !== "") {
        let counts = parseInt(row?.to) - parseInt(row?.from);

        if (counts > 0) {
          return currencyFormatter.format(
            parseFloat(row?.amount) * (counts + 1)
          );
        } else return "";
      } else return "";
    } else {
      return "";
    }
  };

  const getSocialButtonBg = (social_platform) => {
    if (social_platform === "Facebook") return "linkBlue";
    if (social_platform === "Instagram") return "linkRed";
    if (social_platform === "TikTok") return "linkBlack";
  };

  // const [state, setState] = useState([
  //     {
  //         startDate: new Date(),
  //         endDate: addDays(new Date(), 7),
  //         key: 'selection'
  //     }
  // ]);

  const CalendarIcon = () => {
    return (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 14 14"
        fill="currentColor"
        ariahidden="true"
        focusable="false"
        className="rs-picker-toggle-caret rs-icon"
        aria-label="calendar"
      >
        <path d="M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"></path>
      </svg>
    );
  };

  const previewFile = (file, callback) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      callback(reader.result);
    };
    reader.readAsDataURL(file);
  };

  return (
    <>
      {/* <AnimatePresence> */}
      {showCreate ? (
        <>
          <CustomLoader visible={isLoading} />
          <div className="cccc justify-center  items-center flex flex-col fixed  inset-0 z-10 outline-none focus:outline-none">
            <div className=" flex justify-end pr-4 pb-2 lg:pr-8 lg:pb-3  w-full ">
              <img
                onClick={() => setShowCreate(false)}
                alt="cancel_img"
                src={cancel}
                className=" transition ease-in-out delay-150  hover:scale-110  duration-300  cursor-pointer"
              ></img>
            </div>

            <motion.div
              initial={{ opacity: 0, scale: 0.75, y: -200 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0, y: 200 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="w-[95%] pr-2 rounded-lg bg-white "
            >
              <div
                className="sbar overflow-x-hidden max-h-[88vh] overflow-y-auto w-full 
                                    rounded-lg "
              >
                <div className=" font-museo w-[95%] container mx-auto  ">
                  <div className="md:grid  md:gap-6  ">
                    {!isLoading && (
                      <div className="mt-5  md:mt-0 w-full  ">
                        <h4 className="font-museobb mt-2">Create Campaign</h4>
                        <div className="bg-[#0080C4] text-white font-museo my-3 text-lg rounded-lg  ">
                          <p className="px-4">Campaign Details</p>
                        </div>
                        <form
                          onSubmit={handleSubmitForm}
                          action="#"
                          method="POST"
                          className="font-museob"
                        >
                          <div className="overflow-hidden shadow sm:rounded-lg rsuit-custom-input">
                            <div className=" px-4 py-5 sm:p-6  ">
                              <div className="grid grid-cols-6 gap-6 grid-rows-auto  ">
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2 font-museob ">
                                  <label
                                    htmlFor="campaign_title"
                                    className="  block text-sm  text-slate-500"
                                  >
                                    Campaign title
                                  </label>
                                  <input
                                    type="text"
                                    name="campaign_title"
                                    id="campaign_title"
                                    value={formData?.campaign_title}
                                    onChange={(e) =>
                                      handleOnChange(
                                        e.target.value,
                                        "campaign_title"
                                      )
                                    }
                                    autoComplete="address-level2"
                                    className="mt-1 focus:outline-none  placeholder:text-slate-300 block w-full rounded-lg border border-gray-200 bg-white  py-2 px-3 focus:ring-slate-500  sm:text-sm"
                                    placeholder="Campaign title"
                                  />
                                  {hasError(validationErrors, "campaign_title")}
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="budget"
                                    className="block text-sm  text-gray-500"
                                  > 
                                    Budget
                                  </label>
                                  <input
                                    type="text"
                                    name="budget"
                                    id="budget"
                                    pattern="^[1-9]\d*$"
                                    value={formData?.budget}
                                    onChange={(e) =>
                                      handleOnChange(e.target.value, "budget")
                                    }
                                    autoComplete="address-level2"
                                    className="mt-1  focus:outline-none placeholder:text-slate-300 block w-full rounded-lg border border-gray-200 bg-white  py-2 px-3 focus:ring-slate-500  sm:text-sm"
                                    placeholder="RM 00,000"
                                  />

                                  {hasError(validationErrors, "budget")}
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="category"
                                    className="block text-sm  text-gray-500"
                                  >
                                    Category
                                  </label>

                                  <Select
                                    className="mt-1 cm"
                                    classNamePrefix="cPrefix sbar "
                                    placeholder="Select category"
                                    // className="mt-1 "
                                    options={campaignData?.categories_list}
                                    styles={colourStylesStatic}
                                    // isClearable={isClearable}
                                    onChange={(value) =>
                                      handleOnChange(value, "category_id")
                                    }
                                    defaultInputValue={
                                      formData?.category_id !== undefined
                                        ? formData?.category_id.label
                                        : ""
                                    }
                                  />
                                  {hasError(validationErrors, "category_id")}
                                </div>

                                <div className=" relative col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="campaign_title"
                                    className="block text-sm  text-gray-500"
                                  >
                                    Campaign date
                                  </label>

                                  <DatePicker
                                    className={
                                      "mt-1 mClass w-full  rounded-lg border border-gray-200 py-2 px-3"
                                    }
                                    calendarClassName={"calClass"}
                                    clearIcon={null}
                                    calendarIcon={<CalendarIcon />}
                                    required={false}
                                    format="dd-MM-yy"
                                    dayPlaceholder="DD"
                                    monthPlaceholder="MM"
                                    yearPlaceholder="YYYY"
                                    minDate={addDays(new Date(), 0)}
                                    defaultActiveStartDate={new Date()}
                                    onChange={(value) => {
                                      handleOnChangeDatePicker(
                                        "live_date",
                                        value
                                      );
                                    }}
                                    value={
                                      formData?.live_date
                                        ? [new Date(formData?.live_date)]
                                        : ""
                                    }
                                    defaultValue={new Date()}
                                  />
                                  {hasError(validationErrors, "live_date")}
                                </div>

                                <div
                                  ref={refOne}
                                  className=" col-span-6 sm:col-span-6 lg:col-span-2 relative "
                                >
                                  <label
                                    htmlFor="campaign_title"
                                    className="block text-sm  text-gray-500"
                                  >
                                    Duration
                                  </label>
                                  <div>
                                    <DateRangePicker
                                      className={
                                        "mt-1 w-full placeholder:text-slate-300  rounded-lg border border-gray-200 py-2 px-3"
                                      }
                                      calendarClassName={"calClass"}
                                      calendarIcon={<CalendarIcon />}
                                      minDate={addDays(new Date(), 0)}
                                      clearIcon={null}
                                      disable={true}
                                      clearAriaLabel={"Clear value"}
                                      required={false}
                                      format="dd-MM-y"
                                      dayPlaceholder="DD"
                                      monthPlaceholder="MM"
                                      yearPlaceholder="YYYY"
                                      onChange={(value) => {
                                        handleOnChangeDateRangePicker(
                                          "duration",
                                          value
                                        );
                                      }}
                                      value={
                                        formData.duration
                                          ? [
                                              formData.duration.start_date,
                                              formData.duration.end_date,
                                            ]
                                          : ""
                                      }
                                      // defaultValue={formData.duration ? [formData.duration.start_date, formData.duration.end_date] : ''}
                                    />
                                  </div>

                                  {hasError(validationErrors, "duration")}
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="campaign_title"
                                    className="block text-sm  text-gray-500"
                                  >
                                    Description of campaign
                                  </label>
                                  <textarea
                                    name="description"
                                    id="description"
                                    value={formData?.description}
                                    onChange={(e) =>
                                      handleOnChange(
                                        e.target.value,
                                        "description"
                                      )
                                    }
                                    autoComplete="address-level2"
                                    placeholder="Description"
                                    className="  placeholder:text-slate-300 mt-1 block w-full rounded-md border border-gray-200 bg-white py-2 px-3 shadow-sm focus:ring-slate-500 focus:outline-none sm:text-sm"
                                  />
                                  {hasError(validationErrors, "description")}
                                </div>
                              </div>
                            </div>

                            <div className="bg-[#0080C4]  text-white font-museo my-3 text-lg rounded-lg  ">
                              <p className="px-4">Participant Details</p>
                            </div>
                            <div className=" px-4 py-5 sm:p-6  ">
                              <div className="grid grid-cols-6 gap-6 grid-rows-auto">
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="gender"
                                    className="block text-sm  text-gray-500"
                                  >
                                    Gender
                                  </label>

                                  <Select
                                    className="mt-1 rounded-lg  "
                                    classNamePrefix="cPrefix sbar"
                                    placeholder="Select Gender"
                                    closeMenuOnSelect={false}
                                    isMulti
                                    styles={colourStylesStatic}
                                    menuPlacement={"auto"}
                                    options={campaignData?.genderTypes?.map(
                                      (item) => ({
                                        label: item?.name,
                                        value: item?.name,
                                        color: "red",
                                      })
                                    )}
                                    defaultValue={
                                      formData?.gender !== undefined
                                        ? formData?.gender
                                        : []
                                    }
                                    onChange={(value) =>
                                      handleOnChange(value, "gender")
                                    }
                                  />
                                  {hasError(validationErrors, "gender")}
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="country_id"
                                    className="block text-sm  text-gray-500"
                                  >
                                    Location
                                  </label>
                                  <Select
                                    className="mt-1 rounded-lg  "
                                    classNamePrefix="cPrefix sbar"
                                    placeholder="Select Location"
                                    menuPlacement={"auto"}
                                    styles={colourStylesStatic}
                                    value={
                                      formData?.location_id !== undefined
                                        ? formData?.location_id
                                        : ""
                                    }
                                    onChange={(value) =>
                                      handleOnChange(value, "location_id")
                                    }
                                    options={campaignData?.loactions?.map(
                                      (item) => ({
                                        label: item?.name,
                                        value: item?.id,
                                      })
                                    )}
                                  />

                                  {hasError(validationErrors, "location_id")}
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="marital_status"
                                    className="block text-sm  text-gray-500"
                                  >
                                    Marital Status
                                  </label>
                                  <Select
                                    className="mt-1 rounded-lg  "
                                    classNamePrefix="cPrefix sbar"
                                    placeholder="Select Marital Status"
                                    closeMenuOnSelect={false}
                                    isMulti
                                    menuPlacement={"auto"}
                                    styles={colourStylesStatic}
                                    options={campaignData?.maritalStatus?.map(
                                      (item) => ({
                                        label: item?.name,
                                        value: item?.name,
                                      })
                                    )}
                                    defaultValue={
                                      formData?.marital_status !== undefined
                                        ? formData?.marital_status
                                        : []
                                    }
                                    onChange={(value) =>
                                      handleOnChange(value, "marital_status")
                                    }
                                  />

                                  {hasError(validationErrors, "marital_status")}
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2 relative ">
                                  <label
                                    htmlFor="occupation"
                                    className="block text-sm  text-gray-500"
                                  >
                                    Profession
                                  </label>
                                  <Select
                                    placeholder="Select Profession"
                                    closeMenuOnSelect={false}
                                    isMulti
                                    className="mt-1 rounded-lg  "
                                    classNamePrefix="cPrefix sbar"
                                    menuPlacement={"auto"}
                                    styles={colourStylesStatic}
                                    options={campaignData?.occupations?.map(
                                      (item) => ({
                                        label: item?.name,
                                        value: item?.name,
                                      })
                                    )}
                                    defaultValue={
                                      formData?.occupation !== undefined
                                        ? formData?.occupation
                                        : []
                                    }
                                    onChange={(value) =>
                                      handleOnChange(value, "occupation")
                                    }
                                  />
                                  {hasError(validationErrors, "occupation")}
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2 relative ">
                                  <label
                                    htmlFor="Age"
                                    className="block text-sm  text-gray-500"
                                  >
                                    Age
                                  </label>

                                  <Select
                                    className="mt-1 "
                                    placeholder="Select Age"
                                    closeMenuOnSelect={false}
                                    isMulti
                                    menuPlacement={"auto"}
                                    styles={colourStylesStatic}
                                    options={campaignData?.ageRanges}
                                    defaultValue={
                                      formData?.age !== undefined
                                        ? formData?.age
                                        : []
                                    }
                                    onChange={(value) =>
                                      handleOnChange(value, "age")
                                    }
                                  />
                                  {hasError(validationErrors, "age")}
                                </div>

                                <div className="col-span-6 sm:col-span-2">
                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2 mb-2">
                                    <label className="block text-sm  text-gray-500">
                                      Campaign Logo
                                    </label>
                                    <Uploader
                                      listType="picture-text"
                                      disabled={fileList ? true : false}
                                      
                                      defaultFileList={
                                        formData.campaignLogo !== undefined
                                          ? [fileInfo]
                                          : []
                                      }
                                      // value={fileInfo}
                                      multiple={false}
                                      data={{ folder: "campaign" }}
                                      method={"POST"}
                                      className="mt-1 upld "
                                      accept="image/*"
                                      action={ApiUrl.uploadLogo}
                                      onRemove={(file) => {
                                        onRemoveFile(file);
                                      }}
                                      onSuccess={(response, file) => {
                                        handleCamAvatarUpload(response?.file);
                                      }}
                                      onUpload={(file) => {
                                        previewFile(file.blobFile, (value) => {
                                          setFileInfo(file);
                                        });
                                      }}
                                      onError={() => {
                                        setFileInfo(null);
                                      }}
                                    />
                                    {hasError(validationErrors, "campaignLogo")}
                                  </div>
                                </div>
                              </div>
                              {formData?.budget && (
                                <>
                                  <h3> Budget Allocation</h3>
                                  <div className="grid  gap-6 mt-5 font-museob ">
                                    {socialPlatformsData?.map((item) => (
                                      <div
                                        key={item?.value}
                                        className="col-span-6 sm:col-span-6 lg:col-span-2  "
                                      >
                                        <p
                                          onClick={() =>
                                            handleSocialPlateforClick(item)
                                          }
                                          className={`m-auto inline-flex w-28 h-8 items-center justify-center  text-sm font-museob text-center text-white  rounded-lg cursor-pointer focus:ring-4 focus:outline-none ${getSocialButtonBg(
                                            item?.label
                                          )}`}
                                        >
                                          {item?.selected && (
                                            <span className="inline-flex items-center p-1 mr-2 text-sm font-museobb text-gray-800 bg-gray-100 rounded-full dark:bg-gray-700 dark:text-gray-300">
                                              <svg
                                                ariaHidden="true"
                                                className="w-3 h-3"
                                                fill="currentColor"
                                                viewBox="0 0 20 20"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path
                                                  fillRule="evenodd"
                                                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                  clipRule="evenodd"
                                                ></path>
                                              </svg>
                                            </span>
                                          )}
                                          {item?.label}
                                        </p>
                                        {item?.selected &&
                                          item?.range_data?.map(
                                            (rangeData, index) => (
                                              <div
                                                key={index}
                                                className="my-3.5 border border-gray-400  bg-white rounded-lg p-4 flex flex-col justify-between leading-normal  overflow-hidden shadow-lg"
                                              >
                                                <div>
                                                  <span
                                                    onClick={() =>
                                                      handleRangeforClick(
                                                        item,
                                                        rangeData
                                                      )
                                                    }
                                                    className="bg-blue-100 text-blue-800 text-sm font-museob  mt-2 mb-2 mr-2  px-3.5 py-1 rounded cursor-pointer "
                                                  >
                                                    {rangeData?.rangeType}
                                                    {rangeData?.selected && (
                                                      <span className="inline-flex items-center p-1 ml-2 text-sm font-museobb text-gray-800 bg-gray-100 rounded-full dark:bg-gray-700 dark:text-gray-300">
                                                        <svg
                                                          ariaHidden="true"
                                                          className="w-2 h-2 "
                                                          fill="currentColor"
                                                          viewBox="0 0 20 20"
                                                          xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                          <path
                                                            fillRule="evenodd"
                                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                            clipRule="evenodd"
                                                          ></path>
                                                        </svg>
                                                      </span>
                                                    )}
                                                  </span>
                                                  {rangeData?.selected && (
                                                    <div className="mt-3">
                                                      <label
                                                        htmlFor="task_info"
                                                        className="block text-sm  text-gray-500"
                                                      >
                                                        Task Info
                                                      </label>
                                                      <input
                                                        type="text"
                                                        name=""
                                                        required
                                                        value={
                                                          rangeData?.task_info !==
                                                          undefined
                                                            ? rangeData?.task_info
                                                            : ""
                                                        }
                                                        id="task_info"
                                                        onChange={(e) =>
                                                          handleRangeTaskInfoChange(
                                                            e,
                                                            item,
                                                            rangeData
                                                          )
                                                        }
                                                        autoComplete="address-level2"
                                                        className="mt-1 block w-full rounded-md border border-gray-200 bg-white py-2 px-3 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                      />
                                                    </div>
                                                  )}
                                                </div>
                                                {rangeData?.selected && (
                                                  <>
                                                    <h5 className="py-2">
                                                      Budget Range
                                                    </h5>
                                                    <div className="flex justify-around">
                                                      <label className="block text-sm font-museobb text-gray-700">
                                                        From
                                                      </label>
                                                      <label className="block text-sm font-museobb text-gray-700">
                                                        To
                                                      </label>
                                                      <label className="block text-sm font-museobb text-gray-700">
                                                        Amount
                                                      </label>
                                                      <label></label>
                                                    </div>
                                                    {rangeData?.range?.map(
                                                      (r, i) => (
                                                        <div
                                                          key={`budget-ranges-${item?.value}-${index}-${i}`}
                                                          className="block p-6"
                                                        >
                                                          <div className="grid sm:grid-cols-4 grid-rows-4 sm:grid-rows-1  gap-4  ">
                                                            <div className="form-group md:mb-2 ">
                                                              <input
                                                                type="number"
                                                                name=""
                                                                min="0"
                                                                disabled={
                                                                  i > 0
                                                                    ? true
                                                                    : false
                                                                }
                                                                required
                                                                onChange={(e) =>
                                                                  handleRangeChange(
                                                                    e,
                                                                    item,
                                                                    rangeData,
                                                                    r,
                                                                    "from",
                                                                    i
                                                                  )
                                                                }
                                                                id="from"
                                                                placeholder="From"
                                                                value={
                                                                  r.from !==
                                                                  undefined
                                                                    ? r.from
                                                                    : ""
                                                                }
                                                                className="form-control w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-200  rounded   transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                                              />
                                                              {r?.error
                                                                ?.from !==
                                                                undefined && (
                                                                <span className="text-red-600 mt-1 font-museob">
                                                                  {
                                                                    r?.error
                                                                      ?.from
                                                                  }
                                                                </span>
                                                              )}
                                                            </div>
                                                            <div className="form-group md:mb-2">
                                                              <input
                                                                type="number"
                                                                name=""
                                                                min="0"
                                                                required
                                                                id="to"
                                                                placeholder="to"
                                                                onChange={(e) =>
                                                                  handleRangeChange(
                                                                    e,
                                                                    item,
                                                                    rangeData,
                                                                    r,
                                                                    "to",
                                                                    i
                                                                  )
                                                                }
                                                                value={
                                                                  r.to !==
                                                                  undefined
                                                                    ? r.to
                                                                    : ""
                                                                }
                                                                className="form-control block  w-full  px-3 py-1.5  text-base font-normal text-gray-700   bg-white bg-clip-padding border border-solid border-gray-200   rounded transition ease-in-out m-0   focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                                              />
                                                              {r?.error?.to !==
                                                                undefined && (
                                                                <span className="text-red-600 font-museob">
                                                                  {r?.error?.to}
                                                                </span>
                                                              )}
                                                            </div>
                                                            <div className="form-group md:mb-2">
                                                              <input
                                                                type="number"
                                                                name=""
                                                                required
                                                                id="amount"
                                                                placeholder="Amount"
                                                                onChange={(e) =>
                                                                  handleRangeChange(
                                                                    e,
                                                                    item,
                                                                    rangeData,
                                                                    r,
                                                                    "amount",
                                                                    i
                                                                  )
                                                                }
                                                                value={
                                                                  r.amount !==
                                                                  undefined
                                                                    ? r.amount
                                                                    : ""
                                                                }
                                                                className="form-control block   w-full   px-3    py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-200 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                                              />
                                                            </div>

                                                            <div className="form-group md:mb-2 flex sm:flex-row flex-col items-center">
                                                              {currentRowTotal(
                                                                r
                                                              ) !== "" && (
                                                                <div>
                                                                  <span className="bg-blue-100 text-blue-800 text-sm font-museobb inline-flex items-center p-1.5 rounded-full dark:bg-blue-200 dark:text-blue-800 mr-2">
                                                                    <span className="bg-blue-100 text-blue-800 text-sm font-museob mr-2 px-2.5 py-0.5 rounded dark:bg-blue-200 dark:text-blue-800">
                                                                      RM{" "}
                                                                      {currentRowTotal(
                                                                        r
                                                                      )}
                                                                    </span>
                                                                  </span>
                                                                </div>
                                                              )}

                                                              {i > 0 &&
                                                                rangeData?.range
                                                                  ?.length ===
                                                                  i + 1 && (
                                                                  <span
                                                                    onClick={(
                                                                      e
                                                                    ) => {
                                                                      removeRow(
                                                                        e,
                                                                        item,
                                                                        rangeData,
                                                                        r
                                                                      );
                                                                    }}
                                                                    class="inline-flex items-center md:mt-0 mt-2 ml-2 px-4 py-2 bg-red-600 hover:bg-red-700  text-white text-sm font-museob rounded-md cursor-pointer "
                                                                  >
                                                                    <svg
                                                                      xmlns="http://www.w3.org/2000/svg"
                                                                      class="h-5 w-5 mr-2"
                                                                      fill="none"
                                                                      viewBox="0 0 24 24"
                                                                      stroke="currentColor"
                                                                    >
                                                                      <path
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                        strokeWidth="2"
                                                                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                                                      />
                                                                    </svg>
                                                                    Delete
                                                                  </span>
                                                                )}
                                                            </div>
                                                          </div>

                                                          {hasError(
                                                            validationErrors,
                                                            `range-${item?.value}_${rangeData.id}_${r.id}`
                                                          )}
                                                        </div>
                                                      )
                                                    )}

                                                    <div>
                                                      <span
                                                        onClick={(e) => {
                                                          addMoreRows(
                                                            e,
                                                            item,
                                                            rangeData
                                                          );
                                                        }}
                                                        class="inline-flex items-center px-4 py-2 bg-indigo-500 hover:bg-indigo-600 text-white text-sm font-medium rounded-md gap-x-1 cursor-pointer "
                                                      >
                                                        <img
                                                          src={plusAdd}
                                                          className="pr-2"
                                                          alt="plus_add"
                                                        ></img>
                                                        Add
                                                      </span>
                                                    </div>

                                                    <div className="flex justifyContent:center"></div>
                                                  </>
                                                )}
                                              </div>
                                            )
                                          )}
                                      </div>
                                    ))}
                                  </div>
                                </>
                              )}
                            </div>
                            <div className=" px-4 py-2 text-right sm:px-6 flex justify-center items-center ">
                              <button
                                type="submit"
                                className=" font-museob inline-flex justify-center rounded-md border border-transparent bg-greenBtn py-3  px-20 rounded-l-full rounded-r-full text-lg  text-white shadow-sm focus:outline-none
                                                                i  overflow-hidden transform  hover:scale-x-105 hover:scale-y-105 transition duration-300 ease-out"
                              >
                                CREATE
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          <div className="opacity-60 fixed inset-0 z-0 bg-black duration-150 ease-in-out transition  active:shadow-lg "></div>
        </>
      ) : null}
    </>
  );
};

export default CreateCampaignModal;
